"use client";

import { FC } from "react";
import GenerateForm from "components/molecules/GenerateForm";
import * as Styled from "./BattlemapLanding.styled";
export const BattlemapLanding: FC = () => {
  return <Styled.Main suppressHydrationWarning data-sentry-element="unknown" data-sentry-component="BattlemapLanding" data-sentry-source-file="index.tsx">
            <GenerateForm data-sentry-element="GenerateForm" data-sentry-source-file="index.tsx" />
        </Styled.Main>;
};